import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import appuserapi from '@/api/appuserapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'docLuBillCustomActEdit',
  props: {
  appUserLuAct: {
    type: Object,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const inputRef = ref(null)

const emits = __emit

const currDescription = ref(props.appUserLuAct.description)

async function editCustomLuAct() {
  const appUserLuActId = props.appUserLuAct.appUserLuActId;
  const description = currDescription.value.trim();
  await appuserapi.editCustomLuAct(appUserLuActId, description)
  emits('close')
}

async function deleteCustomLuAct() {
  const appUserLuActId = props.appUserLuAct.appUserLuActId;
  await appuserapi.deleteCustomLuAct(appUserLuActId)
  emits('close')
}

onMounted(() => {
  inputRef.value.innerRef.focus()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"margin":"1rem","padding":"1rem","width":"24rem"},
    class: "bg-modal",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('action.update'),
        class: "mtop-02 linebreak cursor-sel",
        styles: "main-h font-l"
      }, null, 8, ["txt"]),
      _createVNode(_component_buttonGroup, {
        class: "mleft-auto",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteCustomLuAct(_ctx.act)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_svg_item, {
            icon: "trash",
            styles: "main-l size-m"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_text_item, {
      txt: _unref(t)('patient.document.luBillAddon.customAct.description'),
      class: "mtop-10",
      styles: "font-mBold"
    }, null, 8, ["txt"]),
    _createVNode(_component_inputBox, { class: "mtop-03" }, {
      default: _withCtx(() => [
        _createVNode(_component_inputLineNew2, {
          ref_key: "inputRef",
          ref: inputRef,
          modelValue: currDescription.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currDescription).value = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (editCustomLuAct()), ["enter"]))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_button_group, {
      class: "mleft-auto mtop-10 psides-10",
      styles: "border-h pad-s",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (editCustomLuAct()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_text_item, {
          txt: _unref(t)('action.update'),
          styles: "font-mBold"
        }, null, 8, ["txt"])
      ]),
      _: 1
    })
  ]))
}
}

})